import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages() {
    const locales = import.meta.glob('../lang/**/*.json', { eager: true, import: 'default' })
    const messages = {}
    Object.keys(locales).forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\.json$/i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = locales[key]
        }
    })
    return messages
}

export default new VueI18n({
    locale: document.documentElement.lang,
    fallbackLocale: process.env.FALLBACK_LOCALE || 'fr',
    messages: loadLocaleMessages()
})